<template>

  <div class="commission-history-modal" ref="commissionHistiryRef">

    <artmisads-modal

      v-model:open="props.showCommissionHistory"

      :title="$t('seller.productDetail.commissionHistoryTitle')"

      :width="960"

      :onCancel="() => props.setShowCommissionHistory(false)"

      :getContainer="() => commissionHistiryRef"

      :destroyOnClose="true"

      :maskClosable="false"

      :footer="null"

    >

      <div class="commission-history">

        <div class="chart" v-if="commissionHistoryList.length">

          <commissionHistoryChart

            :commissionHistoryList="commissionHistoryList"

          />

        </div>

        <div class="export-btn">

          <artmisads-button

            :isSquare="true"

            size="middle"

            v-if="commissionHistoryList.length"

            type="primary"

            @click="onExport"

            >{{ $t('seller.productDetail.export') }}</artmisads-button

          >

          <artmisads-button

            :isSquare="true"

            size="middle"

            v-else

            disabled

            @click="onExport"

            >{{ $t('seller.productDetail.export') }}</artmisads-button

          >

        </div>

        <div class="table">

          <artmisads-table

            :columns="columnsHistory"

            row-key="id"

            :pagination="false"

            rowClassName="table-item"

            :data-source="commissionHistoryList"

          />

        </div>

        <p v-if="commissionHistoryList.length">

          {{ commissionLockNote }}

        </p>

      </div>

    </artmisads-modal>

  </div>

</template>



<script setup>

import moment from 'moment'

import { message } from 'ant-design-vue'

import { ref, watch, computed } from 'vue'

import { useI18n } from 'vue-i18n'

import { productsApi } from '../../../../server/index'

import commissionHistoryChart from './commissionHistoryChart'

import { useUserInfoStore } from '~/storeData/index'



const { t, locale } = useI18n()



const props = defineProps([

  'showCommissionHistory',

  'setShowCommissionHistory',

  'productId',

])

const commissionHistiryRef = ref(null)



const commissionHistoryList = ref([])

const store = useUserInfoStore()



const commissionLockNote = computed(() => {

  locale.value

  const code = store.userInfo.countryCode || 'US'

  const map = {

    US: t('seller.productDetail.commissionLockNoteUS'),

    UK: t('seller.productDetail.commissionLockNoteUK'),

    DE: t('seller.productDetail.commissionLockNoteDE'),

    FR: t('seller.productDetail.commissionLockNoteFR'),

    CA: t('seller.productDetail.commissionLockNoteCA'),

  }

  return map[code] || map.US

})



const getCommissionHistory = async () => {

  const res = await productsApi.getCommissionHistory(props.productId)

  const { success, data, error } = res

  if (success) {

    commissionHistoryList.value = data

  }

}



const buildColumnsHistory = () => [

  {

    title: t('seller.productDetail.colHistoryDate'),

    dataIndex: 'startDate',

    customRender: ({ text, record }) => moment(text).format('YYYY/MM/DD'),

  },

  {

    title: t('seller.productTable.colCommission'),

    dataIndex: 'commission',

    customRender: ({ text, record }) => `${Number(text).toFixed(1)}%`,

  },

  {

    title: t('seller.productDetail.colHistoryDifference'),

    dataIndex: 'difference',

  },

]



const columnsHistory = ref([])

watch(

  () => locale.value,

  () => {

    columnsHistory.value = buildColumnsHistory()

  },

  { immediate: true },

)



const onExport = () => {

  const exportParams = {

    id: props.productId,

  }

  const finalParams = {

    qs: exportParams,

    fileName: t('seller.productDetail.exportCommissionHistoryFile'),

  }

  productsApi.exportCommissionHistory(finalParams)

}



watch(

  () => props.showCommissionHistory,

  (newValue) => {

    if (newValue) {

      getCommissionHistory()

    }

  },

)

</script>



<style lang="less" scoped>

.commission-history-modal {

  .commission-history {

    .export-btn {

      display: flex;

      justify-content: right;

    }

    .table {

      margin-top: 15px;

    }

    > p {

      margin-top: 5px;

      margin-bottom: 15px;

      font-size: 14px;

      line-height: 22px;

      color: var(--dark-3);

    }

  }

}

</style>

